/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Marked_Applied_ErrorInputs */

const en_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to mark as applied`)
};

const de_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konnte nicht als beworben markiert werden`)
};

const fr_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de marquer comme postulé`)
};

const es_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo marcar como postulado`)
};

const it_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile segnare come candidata`)
};

const nl_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markeren als gesolliciteerd mislukt`)
};

const pl_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się oznaczyć jako wysłaną`)
};

const fi_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkitseminen epäonnistui`)
};

const da_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke markere som ansøgt`)
};

const sv_jobs_marked_applied_error = /** @type {(inputs: Jobs_Marked_Applied_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte markera som ansökt`)
};

/**
* | output |
* | --- |
* | "Failed to mark as applied" |
*
* @param {Jobs_Marked_Applied_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_marked_applied_error = /** @type {((inputs?: Jobs_Marked_Applied_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Marked_Applied_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_marked_applied_error(inputs)
	if (locale === "fr") return fr_jobs_marked_applied_error(inputs)
	if (locale === "es") return es_jobs_marked_applied_error(inputs)
	if (locale === "it") return it_jobs_marked_applied_error(inputs)
	if (locale === "nl") return nl_jobs_marked_applied_error(inputs)
	if (locale === "pl") return pl_jobs_marked_applied_error(inputs)
	if (locale === "fi") return fi_jobs_marked_applied_error(inputs)
	if (locale === "da") return da_jobs_marked_applied_error(inputs)
	if (locale === "sv") return sv_jobs_marked_applied_error(inputs)
	return en_jobs_marked_applied_error(inputs)
});